module.exports = __webpack_public_path__ + "media/images/front/icons/icon_login-bb99bcbeaea663ce28352c25001ad9a2.svg";